import type { JSX } from 'react'
import { Sizes } from '@reward-platform/lift/theme/sizes.types'

export enum TravelerType {
  senior = 'senior',
  adult = 'adult',
  youth = 'youth',
  child = 'child',
  infant = 'infant',
  traveler = 'traveler',
}

export type TravelerTypeKey = keyof typeof TravelerType

export interface MinMaxQuantity {
  minCount?: number
  maxCount?: number
}

export interface TravelerData {
  quantity?: number
  limits?: MinMaxQuantity
  isVisible?: boolean
  label?: JSX.Element
  ageRange?: [number, number]
}

export type TravelersQuantity = {
  [key in TravelerTypeKey]: Required<Pick<TravelerData, 'quantity'>>
}

export type Travelers = {
  [key in TravelerTypeKey]?: TravelerData
}

export interface TravelerQuantityPickerProps {
  travelers?: Travelers
  maxTravelers: number
  spacing?: keyof Sizes
  maxTravelersPerRoom?: number
  totalTravelerCount?: number
  variant?: string
  onChange: (travelers: TravelersQuantity) => void
}
